var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Desktop-Dollar--Streamline-Core-Neon",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Desktop Dollar Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop-dollar--cash-desktop-display-device-notification-computer-money-currency"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ea7f4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6 11 -1 2.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ea7f4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8 11 1 2.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#ea7f4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 13.5h6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    stroke: "#ea7f4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.4336 2.44463c-0.0512 -0.14491 -0.1303 -0.27668 -0.2307 -0.38889 -0.2136 -0.23869 -0.5241 -0.3889 -0.8696 -0.3889h-0.9031c-0.5751 0 -1.0414 0.46626 -1.0414 1.04143 0 0.4894 0.3408 0.91278 0.8189 1.01736l1.3749 0.30077c0.5356 0.11716 0.9174 0.59181 0.9174 1.14008 0 0.64435 -0.5224 1.16712 -1.1667 1.16712h-0.7778c-0.508 0 -0.9402 -0.32465 -1.1003 -0.77779",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2489",
    stroke: "#ea7f4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.9445 1.66669V0.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2490",
    stroke: "#ea7f4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.9445 7.5V6.33331",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#215250",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.22227 2 1 2c-0.276142 0 -0.5 0.22386 -0.5 0.5v8c0 0.2761 0.223858 0.5 0.5 0.5h12c0.2761 0 0.5 -0.2239 0.5 -0.5V8.88353",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopDollar);
export default __webpack_public_path__ + "static/media/Desktop-Dollar.973ab8501c56e3244b32f3ccb89104de.svg";
export { ForwardRef as ReactComponent };